import MyCharacterRanking from './MyCharacterRanking';
import ClassRanking from './ClassRanking';
import { getDatasWithOption } from '../../utils/service';
import { getUriParams, getUriCombinedParams } from '../../utils/util';
import { API_DOMAIN_DEFAULT, STATIC_DOMAIN_DEFAULT } from '../../model/model';

class Ranking {
  constructor(options) {
    const _ = this;

    _.option = $.extend({
      wrap: null,
      apiDomain: API_DOMAIN_DEFAULT,
      staticDomain: STATIC_DOMAIN_DEFAULT,
      serverId: 1,
      classCode: 'all', // all : 전체, lord : 군주, knight : 기사, elf : 요정, wizard : 마법사, darkelf : 다크엘프, dragonknight : 용기사, illusionist : 환술사, warrior : 전사, lancer : 창기사, holyknight : 성기사
      isLogin: false,
      global: window
    }, options);

    _.global = _.option.global;

    _.locationParams = null;
    _.classRankingPageIndex = 1;

    _.myCharacterRanking = null;
    _.classRanking = null;
  }

  init() {
    const _ = this;

    _.locationParams = getUriParams(_.global.location.href) || {};
    _.classRankingPageIndex = parseInt(((!_.locationParams || !_.locationParams.classRankingPage) ? 1 : _.locationParams.classRankingPage), 10);

    _.setMyCharacterRanking();
    _.setClassRanking();

    return _;
  }

  setMyCharacterRanking() {
    const _ = this,
      opt = _.option;

    _.myCharacterRanking = new MyCharacterRanking({
      wrap: $('.section-ranking-mycharacter', opt.wrap),
      apiDomain: opt.apiDomain,
      staticDomain: opt.staticDomain,
      serverId: opt.serverId,
      isLogin: opt.isLogin,
      global: _.global
    }).init();
  }

  setClassRanking() {
    const _ = this,
      opt = _.option;

    _.classRanking = new ClassRanking({
      wrap: $('.section-ranking-list', opt.wrap),
      apiDomain: opt.apiDomain,
      serverId: opt.serverId,
      classCode: opt.classCode,
      pageIndex: _.classRankingPageIndex,
      clickPageBtnCallback: function (pageIndex) {
        _.global.location.href = getUriCombinedParams(location.pathname, {
          serverId: opt.serverId,
          classCode: opt.classCode,
          classRankingPage: pageIndex
        });
      },
      global: _.global
    }).init();
  }
}

export default Ranking;


// WEBPACK FOOTER //
// ./_src/js/world/ranking/Ranking.js